// helpers
import DTM from 'shared/helpers/DTM';

export const onPopupLoad = () => {
  DTM.track('redirection_popup_load');
};

export const onPopupCancel = () => {
  DTM.track('redirection_popup_cancel');
};
